import {InfoIcon, QuestionSolidIcon, Tooltip} from "@hosttools/frontend";
import type React from "react";
import {memo} from "react";

export type Props = {
    label: React.ReactNode;
    icon?: "info" | "question";
};

const PopoverInfo: React.FC<Props> = ({label, icon = "question"}) => {
    return (
        <Tooltip interaction label={label}>
            {icon === "question" ? (
                <QuestionSolidIcon color="blueGray.400" size="xs" />
            ) : (
                <InfoIcon color="blueGray.400" size="xs" />
            )}
        </Tooltip>
    );
};

export default memo(PopoverInfo);
